#import "./confluence-reaction-fragment.graphql"

query CommentReactionDetails(
  $contentId: String!
  $contentType: GraphQLReactionContentType!
  $containerId: String!
  $containerType: ContainerType!
  $emojiId: String!
) {
  reactedUsers(
    contentId: $contentId
    containerId: $containerId
    containerType: $containerType
    contentType: $contentType
    emojiId: $emojiId
  ) {
    ...ReactedUsersResponseFragment
  }
}
